import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-canal-midia-social-input-group',
    templateUrl: './canal-midia-social-input-group.component.html',
    styleUrls: ['./canal-midia-social-input-group.component.less']
})
export class CanalMidiaSocialInputGroupComponent {
    /** Canal Mídia Social */
    @Input() canalMidiaSocial: number;
}
